import React, { useEffect, useState } from 'react';
import styles from './shutterModul.scss';
import classNames from 'classnames';
import { Collapse } from 'react-collapse';
import ArrowDownDesktopShutters from '../icons/arrow_down_desktop_shutters';
import ArrowDownMobileShutters from '../icons/arrow_down_mobile_shutters';
import TabNavigationHelper from '../../helper/tabNavigationHelper';

function ShutterModul(props: IShutterModulProp) {
    const tabNavigation = TabNavigationHelper.instance;
    const [showContent, setShowContent] = useState(props.isOpen);
    const idString = 'shutter-' + props.title;
    const contentRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (showContent && props.onIsOpenChange) {
            props.onIsOpenChange(!showContent);
        }

        // disable content if it is not visible, tabNav will skip it then:
        if(contentRef && contentRef.current) {
            tabNavigation.toggleDisabledAtt(contentRef.current, !showContent);
        }
    });

    useEffect(() => {
        // skip during server side rendering or if it is a mobile shop:
        if(typeof window === 'undefined' || props.isMobileShop)
            return;

        // update might come after asynchronous shutter are mounted (mixed&media and Purchase advice):
        setShowContent(props.isOpen);

    }, [props.isOpen]);

    return (
        <div className={classNames(styles.shutter_modul_wrapper,
        {[styles.not_visible]: props.notVisible})}>
            {!props.showPersonalizationBanner &&
                <hr />
            }
            <div className={styles.shutter_modul} data-testid={idString}>
                <div aria-level={3} role='heading' data-testid={'shutter-header'}
                    className={classNames(styles.shutter_header, { [styles.open]: showContent })}
                    onClick={() => {
                        setShowContent(!showContent);
                        if (props.onIsOpenChange)
                            props.onIsOpenChange(!showContent)
                    }}
                    ref={(el)=>tabNavigation.setFocusAtt(el)}
                    onKeyDown={tabNavigation.handleKeyDown}
                    >
                    <div className={styles.shutter_title}>{props.title}</div>
                    {
                        props.icon &&
                        <div className={styles.shutter_icon} data-testid={'shutter-icon'}>
                            {props.icon}
                        </div>
                    }
                    {
                        props.isMobileShop ? (<ArrowDownMobileShutters />) : (<ArrowDownDesktopShutters />)
                    }
                </div>
                <Collapse theme={{ collapse: styles.collapse }} isOpened={showContent}>
                    <div role='textbox' aria-label='content' 
                        className={styles.shutter_content} ref={contentRef}>
                        {props.children}
                    </div>
                </Collapse>
            </div>
        </div >
    );
}

interface IShutterModulProp {
    title?: string;
    isOpen: boolean;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    children?: any;
    icon?: React.ReactNode;
    onIsOpenChange?(open: boolean);
    isMobileShop?: boolean;
    notVisible?: boolean;
    showPersonalizationBanner?;
}

export default ShutterModul;
